import { render, staticRenderFns } from "./lawReviewDetail.vue?vue&type=template&id=10ab8ace"
import script from "./lawReviewDetail.vue?vue&type=script&lang=js"
export * from "./lawReviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ab8ace')) {
      api.createRecord('10ab8ace', component.options)
    } else {
      api.reload('10ab8ace', component.options)
    }
    module.hot.accept("./lawReviewDetail.vue?vue&type=template&id=10ab8ace", function () {
      api.rerender('10ab8ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/review/lawReviewDetail.vue"
export default component.exports